
Greenmile.RouteMonitor = Greenmile.RouteMonitor || {};
Greenmile.RouteMonitor.Routes = (function () {

    var RouteMonitorRoutes = function () {

        this.focusPendingOrderOnMap = function (pendingOrder) {
            var markerLocation;
            var poMarker;
            var marker = new Greenmile.MarkerPendingOrder.GeneralFunctions();
            var map = Monet.Session.Maps.map;

            marker.setMap(map);

            if (!Monet.Session.PendingOrdersNotification.mapLayerIsChecked) {
              marker.removeAllMarkers();
              poMarker = marker.createMarker(pendingOrder);
              if (poMarker._latlng) {
                markerLocation = poMarker.getLatLng();
                map.setView([markerLocation.lat, markerLocation.lng], 16);
                poMarker.addTo(map).openPopup();
              } else {
                new Greenmile.Components.AlertModal('PendingOrders.Location.noLatLgn')
                    .show();
              }
            } else {
              marker.showMarkerById(pendingOrder.get('id'));
            }
        };

        this.showPendingOrderModal = function (pendingOrder) {
            App.Views.RouteSuggestion.showModalFilter(pendingOrder, '#Maps', '#Maps .container');
        };

        this.goToTruck = function (routeView, truckStyle) {

          if (truckStyle === 'goToTruckDisabled') {
              return;
          }

          const { markers } = Monet.Session.Maps.mainMap;
          const { primaryEquipment } = routeView;

            if (markers[primaryEquipment.id] && markers[primaryEquipment.id].coordinates) {

                const m = markers[primaryEquipment.id];

                App.Routers.RouteMonitor.markers.zoomToShowLayer(m, function () {

                    let clusterMarkerFocus;
                    let lat = m._latlng.lat;
                    let lng = m._latlng.lng;
                    let markerFocusIcon;
                    let markerFocus;
                    let dismissFocus;

                    if (typeof (App.Routers.RouteMonitor.prototype.layerFocus) === "undefined") {

                        clusterMarkerFocus = new L.MarkerClusterGroup({
                            maxClusterRadius: 1,
                            spiderfyOnMaxZoom: true,
                            disableClusteringAtZoom: 2, 
                            spiderfyDistanceMultiplier: 3
                        });

                    } else {
                        clusterMarkerFocus = App.Routers.RouteMonitor.prototype.layerFocus;
                    }

                    markerFocusIcon = L.divIcon({
                        html: '<div class="greenmileMarkerFocusIcon"></div>',
                        iconSize: [50, 50]
                    });

                    markerFocus = new L.marker([lat, lng], {
                        icon: markerFocusIcon,
                        zIndexOffset: -1
                    });

                    clusterMarkerFocus.clearLayers();
                    markerFocus.addTo(clusterMarkerFocus);

                    Monet.Session.mainMap.map.addLayer(clusterMarkerFocus, true);
                    App.Routers.RouteMonitor.prototype.layerFocus = clusterMarkerFocus;

                    dismissFocus = function () {
                        App.Routers.RouteMonitor.prototype.layerFocus.clearLayers();
                    };
                    
                    App.Routers.RouteMonitor.prototype.timeoutLayerFocus = App.Routers.RouteMonitor.prototype.timeoutLayerFocus || [];
                    let timeFocus = App.Routers.RouteMonitor.prototype.timeoutLayerFocus;

                    if (timeFocus && timeFocus.length) {
                        const timeOuts = timeFocus;
                        for (const key in timeOuts) {
                            clearTimeout(timeOuts[key]);
                            timeOuts.splice(key, 1);
                        }
                        timeFocus = timeOuts;
                    }

                    const timeout = setTimeout(dismissFocus, 4000);
                    timeFocus.push(timeout);

                    Monet.Session.Maps.map.once('click', dismissFocus);
                });
            }

        };

    };

    return RouteMonitorRoutes;

}());
